export const LOAD__ONBOARDING_PROGRESS = 'LOAD__ONBOARDING_PROGRESS';
export const ADD_OR_UPDATE__ONBOARDING_PROGRESS =
  'ADD_OR_UPDATE__ONBOARDING_PROGRESS';
export const BULK_UPDATE_ONBOARDING_VERSION_STEPS =
  'BULK_UPDATE_ONBOARDING_VERSION_STEPS';
